module.exports = __webpack_public_path__ + "static/media/StudentZole.10b611f6.png";